import { NaturalNumber_Schema } from "@/utilities";

export const CollectibleId_Schema = NaturalNumber_Schema;
